<template>
  <div class="bill_content_wrap">
    <h2>CHI TIẾT CÁC KHOẢN LƯƠNG</h2>
    <div class="bill_content px-4" style="border: 1px solid #e0e0e0; border-radius: 4px;">
      <ChildGroupFee title="Lương trước thuế" :collections="getCollection(getHeadFees('main'))" />
      <TaxExplain />
      <ChildGroupFee title="Điều chỉnh lương" :collections="getCollection(getHeadFees('adjust'))" />
      <ChildGroupFee title="Khoản truy thu" :collections="getCollection(getHeadFees('sub', 'minus'))" />
      <ChildGroupFee title="Khoản hoàn trả" :collections="getCollection(getHeadFees('sub', 'sum'))" />
      <div class="total_money pb-4">
        <h3>Tổng lương thực lĩnh</h3>
        <span>{{ report.totalAfterTax | price }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { get, cloneDeep } from 'lodash-es'
import ChildGroupFee from '@/modules/tuitionFee/detail-period/ChildGroupFee.vue'
import TaxExplain from './TaxExplain.vue'
export default {
  components: {
    ChildGroupFee,
    TaxExplain
  },
  computed: {
    ...mapGetters({
      report: 'salaryReport/report',
      collections: 'salaryCollection/collections'
    })
  },
  methods: {
    getFeeList(category, type = 'sum') {
      const feeIdListByCategory = this.report.salary_heads.filter(x => x.category === category).map(x => x.id)
      if (Array.isArray(feeIdListByCategory) && feeIdListByCategory.length) {
        let feeObject = {}
        if (category === 'main') {
          feeObject = cloneDeep(this.report.sumFees)
        } else if (category === 'adjust') {
          feeObject = cloneDeep({ ...this.report.sumFees, ...this.report.minusFees })
        } else if (type === 'sum') {
          feeObject = cloneDeep(this.report.sumFees)
        } else {
          feeObject = cloneDeep(this.report.minusFees)
        }
        const allowedKeys = Object.keys(feeObject).filter(key => feeIdListByCategory.includes(key))
        if (allowedKeys.length) {
          const result = {}
          allowedKeys.forEach(key => {
            result[key] = feeObject[key]
          })
          return result
        }
      }
      return {}
    },
    getHeadFees(category, type = 'sum') {
      const fee = this.getFeeList(category, type)
      return Object.keys(fee)
        .map(feeId => {
          const info = this.report.salary_heads.find(h => h.id === feeId)
          info.amount = this.getFeeAmount(fee[feeId])
          let notes = fee[feeId].notes
          if (!notes) {
            notes = get(info, 'metadata.subNote', '')
          }
          info.notes = notes
          return info
        })
        .filter(x => x && x.amount > 0)
        .sort((a, b) => a.rank - b.rank)
    },
    getFeeAmount(fee) {
      if (fee.type === 'fixed') return fee.amount
      const headApplyId = fee.salary_head_apply
      if (headApplyId) {
        const feeApplier = this.report.sumFees[headApplyId]
        if (feeApplier) return (fee.amount * feeApplier.amount) / 100
        return 0
      }
      return (fee.amount * this.report.totalSumFee) / 100
    },
    getCollection(headFees) {
      const collections = {}
      for (const headFee of headFees) {
        const collection = headFee.salary_collection
        collections[get(collection, 'id', 'no-group')] = {
          title: get(collection, 'title', 'Khoản điều chỉnh'),
          rank: get(collection, 'rank', 100),
          children: {}
        }
      }
      for (const headFee of headFees) {
        const collection = headFee.salary_collection
        collections[get(collection, 'id', 'no-group')].children[headFee.id] = headFee
      }
      return collections
    }
  }
}
</script>
<style lang="scss" scoped>
.bill_content {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.total_money h3 {
  font-weight: bold;
  font-size: 18px !important;
}
</style>
